import React, { Component } from 'react';
import TerapiLogo from '../../images/desktop_new_logo.svg';
import ObjectiveForm from './ObjectiveForm';
import toast from 'react-hot-toast';


function checkMobile() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (!/mobile/i.test(window.location.host)){
      return "undefined"
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "undefined";
}

class ClosedRoom extends Component {
  constructor(props) {
    super(props);
  };
  
  state = {
    objectives: [],
    idCounter: 1,
    savedObjectives: {},
    clinicTextArea: "",
    professionalEvaluation:0,
    recommendRating:null,
    testimonyText:""
  }

  /* componentDidMount() {
    fetch('')
    .then((response) => response.json())
    .then(objetivesList => {
        this.setState({ objetives: objetivesList });
    });
  } */

  psychologistOptions = [
    "Sin asignar",
    "Ansiedad",
    "Trastorno adaptativo",
    "Depresión o problemas asociados al estado de ánimo",
    "Duelo reciente",
    "Estrés familiar",
    "Estrés laboral",
    "Estrés postraumático",
    "Desarrollo personal y de habilidades sociales",
    "Adicción",
    "Enfermedad profesional",
    "Apoyo en tratamiento psiquiátrico c/s Licencia Médica",
    "Otros"
  ]

  nutritionistOptions = [
    "Sin asignar",
    "Ansiedad (relacionada a la alimentación)",
    "Aumento de masa muscular",
    "Aumento de peso corporal",
    "Control de patologías crónicas y/o metabólicas",
    "Disminución de peso corporal",
    "Mejorar digestión y/o otros trastornos gastrointestinales",
    "Mejorar hábitos de alimentación",
    "Trastornos relacionados a la sobreingesta",
    "Trastornos relacionados a la subingesta",
    "Veganismo/Vegetarianismo",
    "Otros"
  ]

  professionalOptions = this.props.appointment.professional.type=="psychologist" ? this.psychologistOptions : this.nutritionistOptions
  
  addObjectiveHandler = () => {
    this.setState({
      objectives: [...this.state.objectives, 
      <ObjectiveForm 
        key={this.state.idCounter} 
        objectiveId={this.state.idCounter}
        removeObjectiveHandler = {this.removeObjectiveHandler} 
        saved={false}
      />]
    })
    this.setState({idCounter: this.state.idCounter + 1})

  }
  
  removeObjectiveHandler = (objectiveId) => {
    this.state.objectives.forEach((element, index) => {
      if(element.props.objectiveId == objectiveId) this.state.objectives.splice(index, 1)
      this.setState({ objectives: [...this.state.objectives]})
    });
  }

  saveClinicalNotesHandler = () =>{
    const clinicTextNode = document.getElementById("clinic-notes").getElementsByTagName('textarea')[0]
    const clinicText = clinicTextNode.value

    if (clinicText == "") toast.error("Nota clínica vacía");
    else{
      $.ajax({
        type: "POST",
        url: `/${this.props.site}/appointments/update_notes_remote`,
        data: {'token': this.props.roomToken, 'note_text': clinicText},
        dataType: "html"
      })
      .done(function(data){
        toast.success("Nota clínica guardada correctamente");
        }.bind(this)
      )
      .fail(function(data){
        toast.error("Hubo un error al guardar la nota clínica");
        }.bind(this)
      );      
    }
  }

  
  saveObjectivesHandler = () =>{
    const node = document.getElementById("objectives-form-listed")

    let objectives_list = []

    if(node == null || !node.querySelector("input")) toast.error("No hay objetivos")
    else{
      const nodes = node.childNodes
      for(let i=2; i<nodes.length - 1; i++){
        let id = nodes[i].firstChild.id
        let title = nodes[i].getElementsByClassName("objective-title")[0].value
        let description = nodes[i].getElementsByClassName("objective-description")[0].value
        let deadline = nodes[i].getElementsByClassName("objective-deadline")[0].value
        let saved = nodes[i].getElementsByClassName("objetive-form-container")[0].dataset.saved;

        if (saved == "true"){
          continue
        }
  
        if ( title.trim() == "" || description.trim()  == "") {
          toast.error("Debes rellenar todos los campos de los objetivos")
          return
        } else {
          objectives_list.push([id, title, description, deadline])
        }
        // not too efficient but it shouldn't be huge a problem, solution: create some type of dict
      }

      for (let i=0; i < objectives_list.length; i++) {
        // api/therapeutic_objectives  
        $.ajax({
          type: "POST",
          url: `/api/v1/therapeutic_objectives`,
          data: {'user': this.props.appointment.patient.id, 'title': objectives_list[i][1], 'description': objectives_list[i][2], deadline: objectives_list[i][3]},
          dataType: "html"
        })
        .done(function(data){
            // not too efficient but it shouldn't be huge a problem, solution: create some type of dict
            this.state.objectives.forEach((element, index) => {
              if(element.props.objectiveId == objectives_list[i][0]) {
                let new_objectives = [...this.state.objectives];
                let item = {...new_objectives[index]};

                new_objectives[index] = <ObjectiveForm 
                                         key={item.key} 
                                         objectiveId={item.props.objectiveId}
                                         removeObjectiveHandler = {this.removeObjectiveHandler} 
                                         saved={true}
                                        />;
                this.setState({objectives: new_objectives});
              }
            });
            toast.success("Objetivo guardado correctamente");
          }.bind(this)
        )
        .fail(function(data){
            toast.error("Hubo un error al guardar el objetivo");
          }.bind(this)
        );   
        //this.setState(prevState => ({
        //  savedObjetives: [...prevState.savedObjetives, {
        //    id: objectives_list[i][0], 
        //    title: objectives_list[i][1], 
        //    description: objectives_list[i][2],
        //  }]
        //}))
      } 

    } 
  }

  starValueCallHandler = (e) =>{
    let value = e.target.value;
    $.ajax({
      type: "GET",
      url: `/${this.props.site}/appointments/survey_review`,
      data: {'token': this.props.roomToken, 'technical': value},
      dataType: "JSON"
    });
  }

  starValuePsychHandler = e =>{
    let value = e.target.value;
    this.setState({ professionalEvaluation: value});
    $.ajax({
      type: "GET",
      url: `/${this.props.site}/appointments/survey_review`,
      data: {'token': this.props.roomToken, 'quality': value},
      dataType: "JSON"
    });
  }

  addConsultationReason = e => {
    let subject = e.target.value
    $.ajax({
      type: "POST",
      url: `/${this.props.site}/main/psychologists/add_consultation_reason`,
      data: {'token': this.props.roomToken, consultation_reason: subject, professional_id: this.props.appointment.professional.id, patient_id: this.props.appointment.patient.id},
      dataType: "html"
    })
    .done(function(data){
      toast.success("Asignado correctamente");
      }.bind(this)
    )
    .fail(function(data){
      toast.error("No se pudo asignar el motivo de la consulta");
      }.bind(this)
    );
  }

  recommendRatingHandler = e =>{
    let rating = e.target.value
    this.setState({ recommendRating: rating})
  }

  testimonyHandler = e =>{
    let testimony = e.target.value
    this.setState({ testimonyText: testimony})
  }

  testimonyRecommendationSend = e =>{
    e.preventDefault();
    const onSuccessUrl = e.target.href;
    const recommend = this.state.recommendRating
    const testimony = this.state.professionalEvaluation==5 ? this.state.testimonyText : ""
    if ( (recommend != null) || (testimony != "") ){
      $.ajax({
        type: "GET",
        url: `/${this.props.site}/appointments/testimony_recommend`,
        data: {'token': this.props.roomToken, 'testimony': testimony , 'recommend': recommend },
        dataType: "JSON",
        success: (data) => {
          window.location.href = onSuccessUrl;
        },
        error: (data)=>{
          console.log("Falla en el envío")
        }
      });
    }
    else{
      window.location.href = onSuccessUrl;
    }
    return false;
  }

  render() {

    const showMobile = checkMobile();

    const fullButton = {
      width: "100%",
      marginTop: "15px",
      fontSize: "14px"
    };

    const doneColor = {
      color: "green",
      weight: 600
    }

    const ausentColor = {
      color: "red",
      weight: 600
    }

    const notDoneColor = {
      color: "orange",
      weight: 600
    }
    
    const exitColor = {
      color: "#17a2b8",
      weight: 600
    }

    return (
      <div>
        <header className="static">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-6">
                <div id="logo_home" className="img-fluid-2">
                  <img className="image-fluid" height="26" src={ TerapiLogo } />
                </div>
              </div>
            </div>
          </div>
        </header>
        { this.props.holder.type != "user" && 
        <div>

          <div className="content-wraper">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-8">
                  <div className="box_general_3 box_preview" id="consultation-subject">
                    <h3 className="">Motivo de la consulta</h3>
                    <p>Acá puedes definir y guardar el motivo principal de la última sesión realizada con tu paciente.</p>
                    <select className="form-control" id="selectSubject" name="consultation-subject" defaultValue={this.props.appointment.consultationReason ? this.props.appointment.consultationReason : "Sin asignar"} onChange={this.addConsultationReason}>
                      {this.professionalOptions.map((opt,index)=>(
                        <option key={index} disabled={opt=="Sin asignar"} value={opt}>{opt}</option>
                      ))}
                    </select>
                  </div>   
                </div>    
              </div>
            </div>
          </div>
          <div className="content-wraper">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-8">
                  <div className="box_general_3 box_preview" id="clinic-notes">
                    <h3 className="">Notas Clinicas</h3>
                    <p>En esta sección podrás guardar observaciones de la cita, podrás verlas en el perfil de tu paciente.</p>
                    <textarea rows="4" /* value={this.state.clinicTextArea} onChange={(e) => {this.setState({clinicTextArea: e.target.value})} } */ ></textarea>
                    <div className="buttons-container">
                      <a onClick={this.saveClinicalNotesHandler} className="add-button">Guardar</a>
                    </div>                
                  </div>   
                </div>    
              </div>
            </div>
          </div>
          <div className="content-wraper">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-8">
                  <div className="box_general_3 box_preview" id="objectives-form-listed">
                    <h3>Agregar Objetivos</h3>
                    <p>En esta sección podrás agregar objetivos terapéuticos para tu paciente, estos le serán listados en su perfíl. Podrás ver y marcar los objetivos realizados en el perfil de tu paciente.</p>
                    {this.state.objectives}
                    <div className="buttons-container">
                      <a onClick={this.addObjectiveHandler} className="add-button">Agregar Objetivo</a>
                      <a onClick={this.saveObjectivesHandler} className="add-button">Guardar</a>
                    </div>
                  </div>   
                </div>    
              </div>
            </div>
          </div>
        </div>
       }
       <div className="content-wraper">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="box_general_3 box_preview close_session">
                  <h3 className="closedroom-first-title">Tu Sesión Ha Terminado</h3>
                  { this.props.holder.type != "user" && <div>
                    <p> 
                      Para cerrar la sesión debes elegir una de las siguientes opciones: <span style={doneColor}>Realizada</span>: Se realizó correctamente.  <span style={ausentColor}>Ausente</span>: El paciente no se presentó pero se cobrará de todas formas.  <span style={notDoneColor}>No Realizada</span>: No se realizó la consulta y no se cobrará.  <span style={exitColor}>Salir</span>: Si la consulta no ha terminado y deseas volver a la videollamada. 
                    </p>
                  </div>
                  }
                  { this.props.holder.type == "user" &&
                  <div>
                    <div className="stars-rating-videochat-container">  
                      <div className="stars-rating-videochat-title">
                        <img src={this.props.closedRoomImg.secondImg} />
                        <h3><b>¡Gracias por elegirnos!<br/>
                        ¿Nos ayudarías a mejorar evaluando tu experiencia?, sólo te tomará unos segundos.</b></h3>
                        <h3>¿Cómo evaluas la calidad técnica de la videollamada?</h3>
                      </div>

                      <div className="stars-rating-videochat-group">
                        <label className="bad-rated-evaluation-label">Muy mala</label>
                        <span className="rating">
                          <input type="radio" className="rating-input" id="5_star_call_quality" name="rating-input-call-quality" value="5" onClick= {this.starValueCallHandler.bind(this)}></input>
                          <label htmlFor="5_star_call_quality" className="rating-star"></label>

                          <input type="radio" className="rating-input" id="4_star_call_quality" name="rating-input-call-quality" value="4" onClick= {this.starValueCallHandler.bind(this)}></input>
                          <label htmlFor="4_star_call_quality" className="rating-star"></label>

                          <input type="radio" className="rating-input" id="3_star_call_quality" name="rating-input-call-quality" value="3" onClick= {this.starValueCallHandler.bind(this)}></input>
                          <label htmlFor="3_star_call_quality" className="rating-star"></label>

                          <input type="radio" className="rating-input" id="2_star_call_quality" name="rating-input-call-quality" value="2" onClick= {this.starValueCallHandler.bind(this)}></input>
                          <label htmlFor="2_star_call_quality" className="rating-star"></label>

                          <input type="radio" className="rating-input" id="1_star_call_quality" name="rating-input-call-quality" value="1" onClick= {this.starValueCallHandler.bind(this)}></input>
                          <label htmlFor="1_star_call_quality" className="rating-star"></label>
                        </span>
                        <label className="good-rated-evaluation-label">Muy buena</label>
                      </div>
                    </div>

                    <div className="stars-rating-videochat-container">
                      <div className="stars-rating-videochat-title">
                        <h3>¿Cómo evaluas la atención de tu profesional? </h3>
                      </div>

                      <div className="stars-rating-videochat-group">
                        <label className="bad-rated-evaluation-label">Poco útil</label>
                        <span className="rating">
                          <input type="radio" className="rating-input" id="5_star_psych_quality" name="rating-input-psych-quality" value="5" onClick= {this.starValuePsychHandler.bind(this)}></input>
                          <label htmlFor="5_star_psych_quality" className="rating-star"></label>

                          <input type="radio" className="rating-input" id="4_star_psych_quality" name="rating-input-psych-quality" value="4" onClick= {this.starValuePsychHandler.bind(this)}></input>
                          <label htmlFor="4_star_psych_quality" className="rating-star"></label>

                          <input type="radio" className="rating-input" id="3_star_psych_quality" name="rating-input-psych-quality" value="3" onClick= {this.starValuePsychHandler.bind(this)}></input>
                          <label htmlFor="3_star_psych_quality" className="rating-star"></label>

                          <input type="radio" className="rating-input" id="2_star_psych_quality" name="rating-input-psych-quality" value="2" onClick= {this.starValuePsychHandler.bind(this)}></input>
                          <label htmlFor="2_star_psych_quality" className="rating-star"></label>

                          <input type="radio" className="rating-input" id="1_star_psych_quality" name="rating-input-psych-quality" value="1" onClick= {this.starValuePsychHandler.bind(this)}></input>
                          <label htmlFor="1_star_psych_quality" className="rating-star"></label>
                        </span>
                        <label className="good-rated-evaluation-label">Muy útil</label>
                      </div>
                      <div className='recommend-rating-section'>
                        <p className='rating-description-text'>
                          ¿Volverías a utilizar nuestro servicio nuevamente?
                        </p>
                        <div className="recommend-rating-radio-buttons" onChange={this.recommendRatingHandler}>
                          <div className="radio">
                            <input id="radio-1" name="radio" type="radio" value={true}/>
                            <label className="radio-label">Si</label>
                          </div>
                          <div className="radio">
                            <input id="radio-2" name="radio" type="radio" value={false} />
                            <label className="radio-label">No</label>
                          </div>
                        </div>
                      </div>
                      {this.state.professionalEvaluation==5 &&
                        <div className='testimony-rating-section'>
                          <p className='rating-description-text'>
                            ¿Nos compartes un testimonio anónimo sobre cómo te ayuda tu profesional? ¡Tu testimonio nos ayuda a impulsar a más personas a buscar el tratamiento que necesitan!
                          </p>
                          <textarea name="" id="testimony-rating" cols="50" rows="5" onChange={this.testimonyHandler}></textarea>
                        </div>
                      }
                    </div>
                    <hr />
                    <div>
                      <div className="closeroom-options-container">
                        <h3> Reserva tu Próxima Consulta </h3>
                        <div className="closeroom-options-data">
                          <p> Evita perder tu horario y reserva ahora tu próxima consulta </p>
                          <img src={this.props.closedRoomImg.calendarImg} />
                        </div>
                        <a className="btn btn_1" href={`/${this.props.site}/main/users/reservar`} onClick={this.testimonyRecommendationSend}>Ir a Reservar</a>
                      </div>
                      <hr />
                      { /semanal/.test(this.props.appointment.patient.plan) &&
                        <span>
                          <div className="closeroom-options-container">
                            <h3> Upgradear al Plan Mensual </h3>
                            <div className="closeroom-options-data">
                              <p> Ahorra comenzando tu plan mensual </p>
                              <img src={this.props.closedRoomImg.upgradeImg} />
                            </div>
                            <a className="btn btn_1" href={`/${this.props.site}/payments/info-subscripcion`} onClick={this.testimonyRecommendationSend}>Comienza el Plan Mensual</a>
                          </div>
                          <hr />
                        </span>
                      }
                      
                      { this.props.appointment.patient.bookings != null && this.props.appointment.patient.bookings > 2 && showMobile == "Android" &&

                        <span>
                          <div className="closeroom-options-container">
                            <h3> Ayúdanos con tu Calificación </h3>
                            <div className="closeroom-options-data">
                              <p> ¿Hemos sido de utilidad?, nos sería de gran ayuda si nos pudieses ayudar calificándonos
                              en Google Play </p>
                              <img src={this.props.closedRoomImg.evalImg} />
                            </div>
                            <a className="btn btn_1" href="https://play.google.com/store/apps/details?id=com.psycaid.terapi">Califícanos</a>
                          </div>
                          <hr />
                        </span>
                      }
                      
                      { this.props.appointment.patient.bookings != null && this.props.appointment.patient.bookings > 2 && showMobile == "iOS" &&

                        <span>
                          <div className="closeroom-options-container">
                            <h3> Ayúdanos con tu Calificación </h3>
                            <div className="closeroom-options-data">
                              <p> ¿Hemos sido de utilidad?, nos sería de gran ayuda si nos pudieses ayudar calificándonos
                              en la App Store </p>
                              <img src={this.props.closedRoomImg.evalImg} />
                            </div>
                            <a className="btn btn_1" href="https://apps.apple.com/us/app/terapi-psic%C3%B3logos-online/id1547374655">Califícanos</a>
                          </div>
                          <hr />
                        </span>
                      }
                    </div>
                  </div>
                  }

                  { this.props.holder.type != "user" &&
                    <div>
                      <div className="row">
                        <div className="col-lg-12">
                          <a href={`/${this.props.site}/main/psychologists/close_appointment/${this.props.appointment.consultation}/1`} className={`btn btn-success`} style={ fullButton } >
                            Realizada
                          </a>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12">
                          <a href={`/${this.props.site}/main/psychologists/close_appointment/${this.props.appointment.consultation}/2`} className={`btn btn-danger`} style={ fullButton } >
                            Ausente
                          </a>
                        </div>
                      </div>
                       <div className="row">
                        <div className="col-lg-12">
                          <a href={`/${this.props.site}/main/psychologists/close_appointment/${this.props.appointment.consultation}/3`} className={`btn btn-warning`} style={ fullButton } >
                            No Realizada
                          </a>
                        </div>
                      </div>
                    </div>
                  }
                  <div className="exit-button">
                      <a href={this.props.holder.type === "user" ? `/${this.props.site}/app/chat_room` : `/${this.props.site}/app/chat_room`} className="btn btn_1" onClick={this.testimonyRecommendationSend}>
                        Salir
                      </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ClosedRoom;
